import { TextFieldProps } from '@mui/material'

export const formPropsDrawerCrud: Pick<TextFieldProps, 'disabled' | 'size' | 'variant' | 'fullWidth'> = {
  size: 'small',
  variant: 'standard',
  fullWidth: true,
}

export const formPropsShrinkDrawerCrud = {
  ...formPropsDrawerCrud,
  InputLabelProps: { shrink: true },
}
